// Dynamic loading of scenario and customer JSON files using require.context
// This allows loading files dynamically without hardcoding customer names

// Get all scenario JSON files
const scenarioContext = require.context('./scenarios', true, /scenario\.json$/);
const customerContext = require.context('./scenarios', true, /customers\/.*\.json$/);

// Cache for loaded scenarios
const loadedScenariosCache = {};
// Cache for loaded scenario metadata list
let loadedScenariosListCache = null;

// Load scenario and customers from JSON files dynamically
export const loadScenario = (scenarioId) => {
  // Check cache first
  if (loadedScenariosCache[scenarioId]) {
    return loadedScenariosCache[scenarioId];
  }

  // Find scenario.json file
  const scenarioPath = scenarioContext.keys().find(path => {
    const scenario = scenarioContext(path);
    return scenario.id === scenarioId;
  });

  if (!scenarioPath) {
    return null;
  }

  // Load scenario configuration
  const scenarioConfig = scenarioContext(scenarioPath);

  // Load customers dynamically based on scenario.customers list
  const customers = [];
  if (scenarioConfig.customers && Array.isArray(scenarioConfig.customers)) {
    scenarioConfig.customers.forEach(customerFileName => {
      // Find customer file by matching the filename
      const customerPath = customerContext.keys().find(path => {
        // Extract filename from path (e.g., './scenario_01_barcelona_morning/customers/sarah_chen.json')
        const pathParts = path.split('/');
        const fileName = pathParts[pathParts.length - 1];
        return fileName === customerFileName;
      });

      if (customerPath) {
        const customer = customerContext(customerPath);
        customers.push(customer);
      }
    });
  }

  // Combine scenario config with loaded customers
  const loadedScenario = {
    ...scenarioConfig,
    customers
  };

  // Cache the result
  loadedScenariosCache[scenarioId] = loadedScenario;

  return loadedScenario;
};

// Load list of all scenarios with metadata (for scenario selection screen)
export const loadScenarios = () => {
  // Check cache first
  if (loadedScenariosListCache) {
    return loadedScenariosListCache;
  }

  // Get all scenario.json files
  const scenarioPaths = scenarioContext.keys();

  // Load metadata for each scenario
  const scenarios = scenarioPaths.map(scenarioPath => {
    const scenarioConfig = scenarioContext(scenarioPath);

    // Extract only metadata needed for scenario selection
    return {
      id: scenarioConfig.id,
      name: scenarioConfig.name,
      difficulty: scenarioConfig.difficulty,
      description: scenarioConfig.crisis.description,
      time: scenarioConfig.time,
      crisis: scenarioConfig.crisis
    };
  });

  // Sort scenarios by difficulty for consistent ordering
  scenarios.sort((a, b) => a.difficulty - b.difficulty);

  // Cache the result
  loadedScenariosListCache = scenarios;

  return scenarios;
};
